import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/payments.csv']['GET'];

type GetPaymentsResponse = ThisApi['response'];

const getPaymentsCsv = async ({
  creatorId,
  personId,
  search,
  filter,
  startDate,
  endDate,
}: ThisApi['params'] & ThisApi['query']): Promise<GetPaymentsResponse> => {
  const response = await noodleApiClient.get(`/creators/${creatorId}/payments.csv`, {
    params: {
      endDate,
      filter,
      personId,
      search,
      startDate,
    },
  });
  return response.data as GetPaymentsResponse;
};

export default getPaymentsCsv;
